import { IonLabel } from "@ionic/react";

interface ILabel {
    title: string;
    value: string;
    strong?: boolean;
    style?: string;
}

export const LabelComponent = ({ title, value, strong, style }: ILabel) => {
    return (
        <>
            <IonLabel>{strong ? <strong>{title}</strong> : title}</IonLabel>
            <IonLabel>{value}</IonLabel>
        </>
    );
};
